import { useModal } from "./ScalarModal.vue.script.js";
import ScalarModal_default from "./ScalarModal.vue.js";
export { ScalarModal_default as ScalarModal, useModal };
